import Normal from "./Normal";
export default Normal;
